import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Circles } from "react-loader-spinner";
import { clearSession } from "../config/constants";
import { authService } from "../services/authService";
import { UserContext } from "../utils/UserContext";

const LOGOUT_REQUEST_GUARD_KEY = "logoutRequestInProgress";

const Logout = ({ setIsLogin }) => {
  const navigate = useNavigate();
  const { setUser, setWorkshops, setSelectedWorkshop, setActiveOrdersCount } = useContext(UserContext);

  useEffect(() => {
    let timer;

    const performLogout = async () => {
      const shouldNotifyServer = !sessionStorage.getItem(LOGOUT_REQUEST_GUARD_KEY);

      try {
        if (shouldNotifyServer) {
          sessionStorage.setItem(LOGOUT_REQUEST_GUARD_KEY, "true");
          await authService.logout();
        }
      } catch (error) {
        // Si el token ya expiró, igual se limpia el estado local.
        console.warn("No se pudo notificar logout al servidor:", error);
      } finally {
        clearSession();
        setUser(null);
        setWorkshops([]);
        setSelectedWorkshop(null);
        setActiveOrdersCount(0);
        setIsLogin(false);

        timer = setTimeout(() => {
          sessionStorage.removeItem(LOGOUT_REQUEST_GUARD_KEY);
          navigate("/login", { replace: true });
        }, 800);
      }
    };

    performLogout();

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [navigate, setIsLogin, setUser, setWorkshops, setSelectedWorkshop, setActiveOrdersCount]);

  return (
    <div className="logout-page">
      <Circles
        height="80"
        width="80"
        color="#1976d2"
        ariaLabel="logout-loading"
        visible={true}
      />
      <p className="logout-message">Cerrando sesión...</p>
    </div>
  );
};

export default Logout;